import { ossUrl } from '@/utils/config'

const ACTIVITY_MAP = [
  {
    value: 14,
    name: 'growthPlan',
    label: '增长计划'
  },
  {
    value: 17,
    name: 'gatheringPlan',
    label: '点金计划'
  },
  {
    value: 18,
    name: 'customerLock',
    label: '锁客宝'
  }
]

const CONTENT_MAP = {
  growthPlan: { // 增长计划
    name: '油站专属福利',
    icon: `${ossUrl}/persisMarket/activeDetail/gift.png`,
    contentList: [
      '平台补贴：团油会员到站可享<span class="light">¥10+会员券</span>，真金白银实补贴！',
      '独家置顶：5KM范围内，每月<span class="light">置顶油站5</span>天，精准锁定客源！',
      '专属直降：<span class="light">单升价直降活动，击穿周边竞对站</span>！',
      '尊享样式：<span class="light">专属角标</span>标识，提高辨识度！',
      '周末活动：周末<span class="light">会员日</span>，增长计划站，<span class="light">补贴再放大</span>！',
      '数据洞察：AI输出<span class="light">单站报告</span>，精准诊断油站经营！',
      '新媒体免费服务：“抖音、快手、美团”<span class="light">免费宣发</span>，提高油站知名度！',
    ]
  },
  gatheringPlan: { // 聚宝计划
    name: '油站专属权益',
    icon: `${ossUrl}/persisMarket/activeDetail/gift.png`,
    contentList: [
      '增利润-分佣：创造可持续的利润来源，新客享订单油款 9‰ 持续分佣（60 天无交易停止）；老客仅当笔本站订单油款9‰一次性分佣',
      '提流水-锁客：扫码用户发放本站完单返券，优惠券仅本站可用，提升用户在本站的留存率'
    ]
  },
  customerLock: { // 锁客宝
    name: '油站专属权益',
    icon: `${ossUrl}/persisMarket/activeDetail/gift.png`,
    contentList: [
      '强效引流：<span class="light">APP置顶、短信&APP消息精准推送</span>，吸引附近商圈客户',
      '券包促销：本站专属券包，用户可<span class="light">9元享受40元券包（一单回本，首单减10元）</span>，提升到站频次',
      '锁客复购：每周对<span class="light">未使用优惠券进行提醒</span>，促进再次回站加油',
      '私域运营：如满足额外条件，可对油站<span class="light">提供专属的微信私域代运营服务</span>'
    ]
  }
}

const TIPS_MAP = {
  growthPlan: [ // 增长计划
    '1. 依托DeepSeek算法大模型，精准匹配流量，完美提升油站销量；',
    '2. 补贴定向给团油用户：所有营销折扣定向用于团油用户定向引流锁客提频',
    '3. 不截留全用掉：团油不从定向折扣当中截留，全部用于本站营销活动',
    '4. 不截留特指：所有定向折扣，不包含平台日常经营盈利',
    '5. 具体活动以商务洽谈为准',
  ],
  gatheringPlan: [ // 聚宝计划
    '1. 活动期内，油站单独提供营销活动成本',
    '2. 团油的基础让利不能低于3%',
    '3. 具体活动以实际洽谈为准',
  ],
  customerLock: [ // 锁客宝
    '1. 活动期内，油站单独提供营销活动成本',
    '2. 团油的基础让利不能低于其他友商',
    '3. 具体活动以实际洽谈为准',
  ]
}

export {
  ACTIVITY_MAP,
  CONTENT_MAP,
  TIPS_MAP
}
